var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card, CardHeader, CardFooter, CardBody } from 'reactstrap';
import Signals from '../../../signals/Signals';
import { getKey } from '../../../utils/enumUtils';
import SchemaTriggerIntervalValueType from '../../../data/SchemaTriggerIntervalValueType';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import GetServiceSchemasCommand from '../../../commands/services/GetServiceSchemasCommand';
import DeleteServiceSchemaCommand from '../../../commands/services/DeleteServiceSchemaCommand';
import { EmptyDivRow } from '../../components/ui/EmptyRow/EmptyRow';
import SchemaTriggerType from '../../../data/SchemaTriggerType';
import ServiceSchemaOverlay from "./ServiceSchemaOverlay";
import classNames from "classnames";
/**
 *
 */
var ServiceSchemas = /** @class */ (function (_super) {
    __extends(ServiceSchemas, _super);
    /**
     *
     */
    function ServiceSchemas(props) {
        var _this = _super.call(this, props) || this;
        _this.onSortClick = _this.onSortClick.bind(_this);
        _this.onEditSchema = _this.onEditSchema.bind(_this);
        _this.onRemoveSchema = _this.onRemoveSchema.bind(_this);
        _this.onAddSchema = _this.onAddSchema.bind(_this);
        return _this;
    }
    /**
     *
     */
    ServiceSchemas.prototype.componentDidMount = function () {
        this.initialize();
    };
    /**
     *
     * @param nextProps
     * @param nextContext
     */
    ServiceSchemas.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        this.initialize();
    };
    /**
     *
     */
    ServiceSchemas.prototype.initialize = function () {
        var _a = this.context, session = _a.session, serviceSchemaCollection = _a.serviceSchemaCollection;
        var user = session.user;
        var command = new GetServiceSchemasCommand();
        command.execute(user, serviceSchemaCollection);
        if (this.props.overlay) {
            Signals.ShowOverlay.dispatch(React.createElement(ServiceSchemaOverlay, { id: this.props.overlay }));
        }
    };
    /**
     *
     * @returns {*}
     */
    ServiceSchemas.prototype.render = function () {
        var intl = this.props.intl;
        var session = this.context.session;
        if (!this.context.session.isLoggedIn) {
            return null;
        }
        return (React.createElement(Page, { pageName: "service.schemas" },
            React.createElement("div", { className: "h-100 pb-4" },
                React.createElement(Card, { className: "mh-100", style: { width: "95%", borderRadius: "0px 20px 20px 0px" } },
                    React.createElement(CardHeader, { className: "align-items-start flex-grow-0" },
                        React.createElement("h1", { className: 'header-title mr-3' },
                            React.createElement(FormattedMessage, { id: "page.service.schemas.table.title" }))),
                    React.createElement(CardBody, { className: 'overflow-auto' },
                        React.createElement("div", { className: "table-container w-100 h-100 flex-fill table-sm table-responsive" },
                            React.createElement("div", { className: "w-100", style: {
                                    display: "grid",
                                    gridTemplateColumns: "1fr 4fr 1fr 2fr 1fr" + (session.user.isOwner ? " 1fr 1fr" : ""),
                                    rowGap: "1.3rem",
                                    minWidth: "fit-content"
                                } },
                                React.createElement("div", { className: 'w-100 position-sticky text-nowrap text-uppercase bg-secondary px-3 pb-2 table-header', style: { display: "contents", top: 0, zIndex: 1 } },
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "name" },
                                        React.createElement(FormattedMessage, { id: "page.service.schemas.table.column.name" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "description" },
                                        React.createElement(FormattedMessage, { id: "page.service.schemas.table.column.description" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "triggerType" },
                                        React.createElement(FormattedMessage, { id: "page.service.schemas.table.column.interval" })),
                                    React.createElement("div", { className: "text-right", onClick: this.onSortClick, "data-sortBy": "triggerIntervalValue" },
                                        React.createElement(FormattedMessage, { id: "page.service.schemas.table.column.value" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "triggerReminderBeforeIntervalValue" },
                                        React.createElement(FormattedMessage, { id: "page.service.schemas.table.column.triggerreminderbeforeinterval" })),
                                    session.user.isOwner && React.createElement("div", null),
                                    session.user.isOwner && React.createElement("div", null)),
                                this._getRows()))),
                    React.createElement(CardFooter, null,
                        React.createElement("div", { className: "d-flex justify-content-end" }, session.user.isOwner &&
                            React.createElement("button", { className: "btn btn-primary", onClick: this.onAddSchema, type: "submit" },
                                React.createElement("span", { className: "fe fe-plus" }),
                                " ",
                                React.createElement(FormattedMessage, { id: "page.service.schemas.add" }))))))));
    };
    /**
     *
     * @param event
     */
    ServiceSchemas.prototype.onSortClick = function (event) {
        var serviceSchemaCollection = this.context.serviceSchemaCollection;
        var sort = serviceSchemaCollection.sort;
        var fieldName = event.target.dataset.sortby;
        var direction = sort.fieldName === fieldName ? sort.direction * -1 : 1;
        serviceSchemaCollection.sort.update({ fieldName: event.target.dataset.sortby, direction: direction });
        serviceSchemaCollection.updateSortCache();
    };
    /**
     *
     * @return {*}
     * @private
     */
    ServiceSchemas.prototype._getRows = function () {
        var _this = this;
        var _a = this.context, session = _a.session, serviceSchemaCollection = _a.serviceSchemaCollection;
        var classes = classNames({
            'service-schemas__row': true,
            "bg-white": true,
            "w-100": true,
            'mb-4': true,
            "pl-3": true,
            "pr-3": true,
            'pt-4': true,
            'pb-4': true,
        });
        if (serviceSchemaCollection.filtered.length === 0) {
            return React.createElement(EmptyDivRow, null);
        }
        return serviceSchemaCollection.filteredAndSorted.map(function (schema) {
            //
            return (React.createElement("div", { style: { display: "contents" }, key: 'schema-' + schema.id, className: classes },
                React.createElement("div", { className: "" }, schema.name),
                React.createElement("div", { className: "text-muted" }, schema.description),
                React.createElement("div", { className: "text-nowrap" },
                    React.createElement(FormattedMessage, { id: 'service.schema.triggertype.' + SchemaTriggerType[schema.triggerType] })),
                React.createElement("div", { className: "text-nowrap text-right" },
                    schema.triggerIntervalValue,
                    " ",
                    React.createElement(FormattedMessage, { id: 'service.schema.triggerintervaltype.' + getKey(schema.triggerIntervalValueType, SchemaTriggerIntervalValueType) })),
                React.createElement("div", { className: "text-nowrap text-right" },
                    SchemaTriggerIntervalValueType.isPeriodial(schema.triggerIntervalValueType) ? schema.triggerReminderBeforeIntervalValue / 86400000 : schema.triggerReminderBeforeIntervalValue,
                    " ",
                    SchemaTriggerIntervalValueType.isPeriodial(schema.triggerIntervalValueType) ?
                        React.createElement(FormattedMessage, { id: "page.service.schema.reminderdays" }) :
                        React.createElement(FormattedMessage, { id: "page.service.schema.reminderoperationalhours.short" })),
                session.user.isOwner ?
                    React.createElement("div", { className: "align-middle text-nowrap" },
                        React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: _this.onEditSchema, "data-id": schema.id },
                            React.createElement("i", { className: "fe fe-edit-2" }),
                            " ",
                            React.createElement(FormattedMessage, { id: "page.service.schemas.edit" }))) : null,
                session.user.isOwner ?
                    React.createElement("div", { className: "pr-4 align-middle text-nowrap" },
                        React.createElement("button", { className: "btn btn-sm btn-outline-danger", onClick: _this.onRemoveSchema, "data-id": schema.id },
                            React.createElement("i", { className: "fe fe-trash" }),
                            " ",
                            React.createElement(FormattedMessage, { id: "page.service.schemas.remove" }))) : null));
        });
    };
    /**
     *
     * @param event
     */
    ServiceSchemas.prototype.onEditSchema = function (event) {
        var schemaId = event.currentTarget.dataset.id;
        Signals.ShowOverlay.dispatch(React.createElement(ServiceSchemaOverlay, { id: schemaId }));
        // History.push(Routes.SERVICE_SCHEMAS_EDIT.getPath({id: schemaId}));
    };
    /**
     *
     * @param event
     */
    ServiceSchemas.prototype.onRemoveSchema = function (event) {
        var intl = this.props.intl;
        var serviceSchemaCollection = this.context.serviceSchemaCollection;
        var schemaId = event.currentTarget.dataset.id;
        var session = this.context.session;
        var schema = serviceSchemaCollection.findById(schemaId);
        //title, body, confirmText = 'Ok', cancelText = 'Cancel', onConfirm = null, onCancel = null
        Signals.ShowConfirmModal.dispatch(intl.formatMessage({ id: 'page.service.schemas.removeschema.confirm.title' }, schema), intl.formatMessage({ id: 'page.service.schemas.removeschema.confirm.body' }, schema), intl.formatMessage({ id: 'page.service.schemas.removeschema.confirm.yes' }, schema), intl.formatMessage({ id: 'page.service.schemas.removeschema.confirm.no' }, schema), function () {
            var command = new DeleteServiceSchemaCommand();
            command.execute(session.user.organisation, schema, serviceSchemaCollection, intl);
        });
    };
    ServiceSchemas.prototype.onAddSchema = function () {
        Signals.ShowOverlay.dispatch(React.createElement(ServiceSchemaOverlay, { id: 'add' }));
    };
    ServiceSchemas = __decorate([
        observer
    ], ServiceSchemas);
    return ServiceSchemas;
}(React.Component));
ServiceSchemas.contextType = ApplicationContext;
export default injectIntl(ServiceSchemas);
